import dateService from "../../../../common/utils/date/date.service";
import GoogleMapsRouteWaypoint from "../../../../common/utils/google-maps-route/google-maps-route-waypoint";
import googleMapsRouteService from "../../../../common/utils/google-maps-route/google-maps-route.service";
import orderOptimizerTranslationsHelper from "../../../../languages/order-optimizer-translations.helper";
import { OrderOptimizerCargoDetailsItemStepsOrdersPoints } from "./common/types/order-optimizer-cargo-details-item";

const getHeadingText = (id: string) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoDetailsTranslations();

  if (!id) {
    return "";
  }

  return translations.heading.headingLabel.replace("#{id}", id);
};

const getDateLabel = (date: Date | null): string => {
  if (!date) {
    return "---";
  }

  return dateService.formatDateTime(date);
};

const getTimeLabel = (date: Date | null): string => {
  if (!date) {
    return "---";
  }

  return dateService.formatTime(date);
};

const getTimeDeltaLabel = (timeDeltaSeconds: number = 0): string => {
  let timeDelteNegative = false;

  if (timeDeltaSeconds < 0) {
    timeDeltaSeconds = -timeDeltaSeconds;
    timeDelteNegative = true;
  }

  const hours = Math.floor(timeDeltaSeconds / 3600);
  const minutes = Math.floor((timeDeltaSeconds % 3600) / 60);

  return `${timeDelteNegative ? "- " : ""}${String(hours).padStart(2, "0")}:${String(
    minutes,
  ).padStart(2, "0")} h`;
};

const getSavingLabel = (saving: number): string => {
  return `${saving.toFixed()}%`;
};

const calculateSaving = (
  totalCargoIncome: number,
  totalDriverHaltingCost: number,
  distance: number,
  rate: number,
) => {
  return (
    100 *
    ((totalCargoIncome - (totalDriverHaltingCost + distance * rate)) /
      totalCargoIncome)
  );
};

const getGoogleMapsUrl = (
  points: OrderOptimizerCargoDetailsItemStepsOrdersPoints[],
  driverHomeLat?: number,
  driverHomeLon?: number,
  lastPoint?: boolean,
) => {
  let waypoints = points.map((point): GoogleMapsRouteWaypoint => {
    return {
      latitude: point.lat,
      longitude: point.lon,
    };
  });

  if (lastPoint && driverHomeLat && driverHomeLon) {
    const driverHome: GoogleMapsRouteWaypoint = {
      latitude: driverHomeLat,
      longitude: driverHomeLon,
    };
    waypoints = [...waypoints, driverHome];
  }

  return googleMapsRouteService.createGoogleMapsRouteUrl(waypoints);
};

const getDistanceLabel = (distance: number = 0) => {
  return `${distance.toFixed()} KM`;
};

const getScoreLabel = (score?: number) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoDetailsTranslations();

  return `${translations.table.scoreLabel} ${score?.toFixed() ?? "---"}`;
};

const getIdLabel = (id?: number) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoDetailsTranslations();

  return `${translations.table.idLabel} ${id ?? "---"}`;
};

const orderOptimizerCargoDetailsHelper = {
  getHeadingText,
  getDateLabel,
  getTimeLabel,
  getTimeDeltaLabel,
  getDistanceLabel,
  getSavingLabel,
  calculateSaving,
  getGoogleMapsUrl,
  getScoreLabel,
  getIdLabel,
};

export default orderOptimizerCargoDetailsHelper;
